import { AppBar, Tooltip, ListItem, ListItemIcon } from '@material-ui/core';
import React, { useContext } from 'react';

import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { UserContext } from './../Context/UserContext';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Logo } from './Components/Icons';
import AppLink from './Components/AppLink';
import { routes } from '../Routing/routes';
import { apiClient } from '../API/Auth/apiClient';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
	root: {
		background: '#0033EA',
		zIndex: theme.zIndex.modal - 1,
		boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.25)',
		height: '90px',
	},
	toolBar: {
		minHeight: '90px',
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	logo: {
		flexGrow: 1,
		display: 'flex',
		marginTop: '40px',
	},
	info: {
		margin: theme.spacing(2),
		color: 'white',
		justifyContent: 'spaceBetween',
	},
}));

interface Props {
	toggleDrawerOpen: () => void;
}

const ApplicationBar: React.FC<Props> = (props) => {
	const userContext = useContext(UserContext);
	const classes = useStyles(props);
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const { t } = useTranslation();

	return (
		<AppBar id='appbar' position='fixed' className={classes.root}>
			<Toolbar className={classes.toolBar}>
				{isMobile && userContext.isLogged && (
					<IconButton
						edge='start'
						className={classes.menuButton}
						color='primary'
						aria-label='menu'
						onClick={props.toggleDrawerOpen}
					>
						<MenuIcon />
					</IconButton>
				)}

				<div className={classes.logo}>
					<Logo />
				</div>

				{userContext.isLogged && (
					<>
						<Typography color='secondary' style={{ paddingRight: '8px' }}>
							{userContext.userLogin}
						</Typography>

						<Tooltip title={t('menu.logout') || ''}>
							<AppLink to={routes.root} onClick={() => apiClient.logout(true)}>
								<ListItem button>
									<ListItemIcon style={{ justifyContent: 'center', minWidth: '0' }}>
										<ExitToAppIcon style={{ color: 'white' }} />
									</ListItemIcon>
								</ListItem>
							</AppLink>
						</Tooltip>
					</>
				)}
			</Toolbar>
		</AppBar>
	);
};

export default ApplicationBar;
